import { Action } from 'redux';
import _ from 'underscore';

import { isSiteNamesRequestSucceededAction } from '../actions/SitesNamesRequestAction';
import { ISiteNameSansId } from '../serverApi/types/ISiteNameSansId';

const InitialState: ReadonlyArray<ISiteNameSansId> = [];

export function sitesReducer(
  previousState: ReadonlyArray<ISiteNameSansId> = InitialState,
  action: Action
): ReadonlyArray<ISiteNameSansId>  {
  if (isSiteNamesRequestSucceededAction(action)) {
    if (action.sites && !_.isEqual(action.sites, previousState)) {
      return action.sites;
    }
  }

  return previousState;
}
